import actions from "../../actions";

const initialState = {
  from_date: null,
  to_date: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.dashboard.sessionsFilter.SET_FROM_DATE:
      return {
        ...state,
        from_date: new Date(action.date),
      };
    case actions.dashboard.sessionsFilter.SET_TO_DATE:
      return {
        ...state,
        to_date: new Date(action.date),
      };
    case actions.dashboard.sessionsFilter.RESET_FILTERS:
      return initialState;
    default:
      return state;
  }
};
